// Company FS custom Level-3 node API (PL-COT / PL-OI / PL-AE children)
import {BASE_AUDIT_API, fetchAPI} from '@/services/api';

const base = `${BASE_AUDIT_API}/company-fs-custom-node`;

export interface AuditCompanyFSCustomNodeVO {
    id?: number;
    companyId?: number;
    statement?: string;
    parentFsId?: number;
    parentCode?: string;
    customCode?: string;
    nameEn?: string;
    nameZh?: string;
    scheduleName?: string;
    entry?: string;
    templateCodeRef?: string;
    displayOrder?: number;
    fsId?: number;
    hasLinkedData?: boolean;
}

export interface AuditCompanyFSCustomNodeCreatePayload {
    companyId: number;
    parentFsId: number;
    /** Optional PL-COT / PL-OI / PL-AE — backend fallback when fsId Feign lookup misses */
    parentCode?: string;
    nameEn: string;
    nameZh?: string;
    entry?: string;
    displayOrder?: number;
}

export interface AuditCompanyFSCustomNodeUpdatePayload {
    id: number;
    companyId: number;
    nameEn?: string;
    nameZh?: string;
    entry?: string;
    displayOrder?: number;
}

/** POST /company-fs-custom-node/create */
export async function createCustomNode(payload: AuditCompanyFSCustomNodeCreatePayload) {
    return fetchAPI<AuditCompanyFSCustomNodeVO>(`${base}/create`, {
        method: 'POST',
        body: JSON.stringify(payload),
    });
}

/** PUT /company-fs-custom-node/update */
export async function updateCustomNode(payload: AuditCompanyFSCustomNodeUpdatePayload) {
    return fetchAPI<AuditCompanyFSCustomNodeVO>(`${base}/update`, {
        method: 'PUT',
        body: JSON.stringify(payload),
    });
}

/** DELETE /company-fs-custom-node/delete */
export async function deleteCustomNode(companyId: number, id: number, confirmed = false) {
    return fetchAPI<boolean>(
        `${base}/delete?companyId=${companyId}&id=${id}&confirmed=${confirmed ? 'true' : 'false'}`,
        {method: 'DELETE'},
    );
}

/** GET /company-fs-custom-node/listByCompany */
export async function listCustomNodesByCompany(companyId: number) {
    return fetchAPI<AuditCompanyFSCustomNodeVO[]>(
        `${base}/listByCompany?companyId=${companyId}`,
        {method: 'GET'},
    );
}

/** GET /company-fs-custom-node/deleteCheck */
export async function deleteCheckCustomNode(companyId: number, id: number) {
    return fetchAPI<AuditCompanyFSCustomNodeVO>(
        `${base}/deleteCheck?companyId=${companyId}&id=${id}`,
        {method: 'GET'},
    );
}

/** GET /company-fs-custom-node/quota � Admin max custom nodes (default 5) */
export async function getCustomNodeQuota(companyId: number) {
    return fetchAPI<number>(`${base}/quota?companyId=${companyId}`, {method: 'GET'});
}

/** PUT /company-fs-custom-node/quota */
export async function saveCustomNodeQuota(companyId: number, maxNodes: number) {
    return fetchAPI<number>(
        `${base}/quota?companyId=${companyId}&maxNodes=${maxNodes}`,
        {method: 'PUT'},
    );
}
